import React, { createContext, useState, useContext, useEffect } from 'react';

import { MyContext } from '../ProviderContext';

export const Procurement = () => {
    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: 'active', team: '', contact: '', project: '' });
    }, [])

    return (
        <>
            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Strategic Procurment</h2>
                        </div>
                        <div className="col-12">
                            <a href="">Home</a>
                            <a href="">Strategic Procurement</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <img src='/img/procurement-1.png' width="100%" />
                        <p className=' about-text'>
                            You get  <span style={{ color: 'red' }}>accurate designs</span> that are  <span style={{ color: 'red' }}>compliant with international codes and standards</span> and certified by our engineers who are recognized engineers with
                            COREN, NSE, SPE, ASME, ASTM, etc. Our engineers are tech savvy with hands-on knowledge of designing with the latest computer aided engineering design software
                        </p>
                        <img src='/img/procurement-2.png' width='100%'></img>
                        <p>Casing Pipes and Wellhead Casing Spools imported from our partners Hunan Standard Steel Co. Ltd of Husteel Industry Group whom Frantino Multiple Services Ltd is their authorized representative in OCTG and Drilling Equipment in Nigeria.</p>
                    </div>
                    <div className='col-4 about-text'>
                        <p>
                            We utilize a highly effective procurement and logistics management software called <span style={{color:'red'}}> Logisuite</span> to manage our procurement and supply chain process to ensure our customers and stakeholders are satisfied with our service.
                        </p>

                        <img src='/img/logistics-offload.png' width='100%' />
                        Off-Loading of Citadel Fence materials imported from our partner OEM Hebei Hengshi Wire Mesh Trade Co. Ltd who we represent exclusively in Africa.
                    </div>
                </div>
               
            </div>
        </>
    )
}